import { Box, IconButton } from '@mui/material';
import { Add, DeleteOutline } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { YesNo } from '@uplift/types';
import { Button, TextInput, Tooltip } from '@uplift/ui-v2';
import { FieldArray, FieldArrayRenderProps, Form, useFormikContext } from 'formik';
import { Fragment } from 'react';
import { SectionContainerContent, SectionContainerDivider, YesNoRadioControl } from '../../components';
import { treatmentObjInitialValue } from '../../helpers';
import { ClinicalNotesFormType } from '../../types';
import { useSectionStyles } from '../styles';
import { TreatmentForm } from './treatment.form';

export const Treatment: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useSectionStyles();
  const formik = useFormikContext<ClinicalNotesFormType>();
  const treatments = formik.values.treatment;

  const hasMultiple = treatments.length > 1;

  const renderFieldArray = (arrayHelpers: FieldArrayRenderProps) => {

    return (
      <Fragment>
        {treatments.map((treatment, index) => {
          const hasOverallError = !!formik.errors?.treatment?.[index];
          const hasTouched = !!formik.touched?.treatment?.[index]?.treatmentApproachId
                && !!formik.touched?.treatment?.[index]?.interventionIds;

          const showOverallError = hasOverallError && hasTouched;

          return (
            <Box key={treatment.treatmentApproachId} display="flex" alignItems="center" mb={3}>
              <Box className={showOverallError ? classes.lightRedBackground : classes.greyBackground} p={3} flex={1} mr={1}>
                <TreatmentForm arrayHelpers={arrayHelpers} index={index} />
              </Box>
              <Tooltip title={l10n.clinicalNotes.delete} placement="top">
                <IconButton
                  onClick={() => arrayHelpers.remove(index)}
                  className={hasMultiple ? undefined : classes.visibilityHidden}
                >
                  <DeleteOutline />
                </IconButton>
              </Tooltip>
            </Box>
          );
        })}
        <Box ml={-1}>
          <Button
            onClick={() => arrayHelpers.push(treatmentObjInitialValue)}
            color="secondary"
            variant="text"
            startIcon={<Add />}
          >
            {l10n.clinicalNotes.addApproach}
          </Button>
        </Box>
      </Fragment>
    );
  };

  const showHomeworkForm = formik.values.treatmentHomeworkYesNo === YesNo.Yes;

  return (
    <>
      <SectionContainerContent>
        <FieldArray
          name="treatment"
          render={renderFieldArray}
        />
      </SectionContainerContent>
      <SectionContainerDivider />
      <SectionContainerContent>
        <YesNoRadioControl
          baseName="treatmentHomework"
          label={l10n.clinicalNotes.assignHomework}
        />
      </SectionContainerContent>
      {showHomeworkForm && (
        <SectionContainerContent className={classes.greyBackground}>
          <Form>
            <TextInput
              color="secondary"
              label={l10n.clinicalNotes.homework}
              name="treatmentHomework"
              multiline
              rows={1}
              className={classes.inputBackgroundWhite}
              fullWidth
            />
          </Form>
        </SectionContainerContent>
      )}
    </>
  );
};
